import { render } from "./AddCaseNoteDialog.vue?vue&type=template&id=3228d7ab&ts=true"
import script from "./AddCaseNoteDialog.vue?vue&type=script&lang=ts"
export * from "./AddCaseNoteDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__